import { render, staticRenderFns } from "./PolicyUpdateSection.vue?vue&type=template&id=6a209229&scoped=true"
import script from "./PolicyUpdateSection.vue?vue&type=script&lang=js"
export * from "./PolicyUpdateSection.vue?vue&type=script&lang=js"
import style0 from "./PolicyUpdateSection.vue?vue&type=style&index=0&id=6a209229&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a209229",
  null
  
)

export default component.exports